import { useSelector, useDispatch } from 'react-redux';
import * as lessonSelectors from '../selectors';
import * as lessonActions from '../actions';
import { STATUS } from '../constants';
import { useEffect } from 'react';

export const useQuizStats = (lessonId, questionId = null) => {
  // note this redux routine loads them by lesson but selects by question

  const dispatch = useDispatch();

  const quizStats = useSelector((state) =>
    lessonSelectors.getQuizStatsByQuestionId(state, questionId)
  );

  const quizStatsLoadingStatus = useSelector((state) =>
    lessonSelectors.getQuizStatsByLessonIdStatus(state, lessonId)
  );

  useEffect(() => {
    if (quizStatsLoadingStatus === STATUS.UNINITIALIZED) {
      dispatch(lessonActions.loadQuizStatsByLessonId.signal(lessonId));
    }
  }, [dispatch, lessonId, quizStatsLoadingStatus]);

  return {
    data: quizStats,
    isLoading: [STATUS.LOADING, STATUS.SUBMITTING].includes(
      quizStatsLoadingStatus
    ),
    error:
      quizStatsLoadingStatus === STATUS.ERROR
        ? 'Error loading Quiz Attempts'
        : null,
  };
};
